import { I18N_KEYS } from './keys';

const EN_TEXT = {
  [I18N_KEYS.COMMON_COMPONENTS.COPYRIGHT]: '© 2026 Figma Weave. All rights reserved.',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.CTA]: 'Drag & drop or click to upload',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.NO_PREVIEW]: 'No preview',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.OR]: 'Or',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.PASTE_LINK]: 'Paste a file link',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.REMOVE_FILE]: 'Remove File',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.REPLACE_FILE]: 'Click to replace',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.ADD_FILE]: 'Drop to add',
  [I18N_KEYS.COMMON_COMPONENTS.FILE_UPLOADER.UPLOAD_FROM_LINK]: 'Upload from link',
  [I18N_KEYS.COMMON_COMPONENTS.NODE_IMAGE_LIST.NO_PREVIEW]: 'No Preview Available',
  [I18N_KEYS.COMMON_COMPONENTS.NODE_IMAGE_LIST.RESULT]: 'Result',
  [I18N_KEYS.COMMON_COMPONENTS.THREE_DEE_VIEWER.ERROR]: 'Error in Three.js boundary',
  [I18N_KEYS.COMMON_COMPONENTS.BASE_SELECT.NO_OPTIONS_TEXT]: 'No options available',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.TITLE]: 'High cost run',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.SUBTITLE]:
    'This run will cost <icon/><b>{{cost}} credits</b>.\nAre you sure you want to continue?',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.CHECKBOX_LABEL]: "Don't show this again",
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.CTA_CONFIRM]: 'Confirm',
  [I18N_KEYS.COMMON_COMPONENTS.EXPENSIVE_RUN_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.TITLE + '_long']: 'Total cost',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.TITLE + '_short']: 'Total',
  [I18N_KEYS.COMMON_COMPONENTS.PRICE_INFO.CREDITS]: '{{count}} credits',

  [I18N_KEYS.COMPOSITOR.LAYER_PANEL.TITLE]: 'Layers',
  [I18N_KEYS.COMPOSITOR.LAYER_PANEL_ROW.CANVAS_LAYER_NAME]: 'Canvas',
  [I18N_KEYS.COMPOSITOR.MISSING_URL_TOOLTIP]: 'Connect a valid image to enable this layer.',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.TITLE]: 'Replace missing fonts',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.DESCRIPTION]:
    'This workflow uses custom fonts that are not available for this recipe. Text may not look correct until those fonts are uploaded to the workspace.',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.CONTINUE]: 'Continue',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.COLUMN_MISSING]: 'Missing font',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.COLUMN_REPLACEMENT]: 'Replacement',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.SELECT_FONT]: 'Select font',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.MIXED_REPLACEMENT_FONT]: 'Mixed',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.SELECT_STYLE]: 'Select style',
  [I18N_KEYS.COMPOSITOR.MISSING_WORKSPACE_FONTS_MODAL.REPLACE]: 'Replace',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FLIP]: 'Flip',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGNMENT]: 'Alignment',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODE]: 'Blend mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.CANVAS_LAYER_NAME]: 'Canvas',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.DIMENSIONS]: 'Dimensions',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.TIMELINE]: 'Timeline mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.TIMELINE_INFO]: 'Timeline mode',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.DURATION]: 'Duration',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FPS]: 'Frame rate',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FILL]: 'Fill',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT]: 'Font',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_LETTER_SPACING]: 'Letter spacing',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_LINE_HEIGHT]: 'Line height',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_ALIGN]: 'Alignment',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SIZE]: 'Size',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_STYLE]: 'Style',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.OPACITY]: 'Opacity',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.POSITION]: 'Position',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ROTATION]: 'Rotation',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHT]: 'Weight',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.NORMAL]: 'Normal',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.MULTIPLY]: 'Multiply',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.SCREEN]: 'Screen',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.OVERLAY]: 'Overlay',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.DARKEN]: 'Darken',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.LIGHTEN]: 'Lighten',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.COLOR_DODGE]: 'Color Dodge',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.COLOR_BURN]: 'Color Burn',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.HARD_LIGHT]: 'Hard Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.SOFT_LIGHT]: 'Soft Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.DIFFERENCE]: 'Difference',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.EXCLUSION]: 'Exclusion',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.HUE]: 'Hue',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.SATURATION]: 'Saturation',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.COLOR]: 'Color',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.LUMINOSITY]: 'Luminosity',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.BLEND_MODES.ADD]: 'Add',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.HELPER_TEXT]:
    'Want to add your own font? Contact us at <supportEmail>support@weavy.ai</supportEmail>',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_SELECT_INPUT.NO_OPTIONS_TEXT]: 'No fonts match this search',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_STYLES.NORMAL]: 'Normal',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_STYLES.ITALIC]: 'Italic',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.THIN]: 'Thin',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.EXTRA_LIGHT]: 'Extra Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.LIGHT]: 'Light',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.REGULAR]: 'Regular',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.MEDIUM]: 'Medium',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.SEMI_BOLD]: 'Semi Bold',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.BOLD]: 'Bold',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.EXTRA_BOLD]: 'Extra Bold',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.BLACK]: 'Black',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.FONT_WEIGHTS.EXTRA_BLACK]: 'Extra Black',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.TOP]: 'Top',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.CENTER]: 'Center',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.BOTTOM]: 'Bottom',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.LEFT]: 'Left',
  [I18N_KEYS.COMPOSITOR.LAYER_PROPERTY_PANEL.ALIGN_OPTIONS.RIGHT]: 'Right',

  [I18N_KEYS.DASHBOARD.DUPLICATE_SUCCESS]: 'Workflow duplicated to "My Files".',
  [I18N_KEYS.DASHBOARD.DUPLICATE_SUCCESS_ACTION]: 'Open "My Files"',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.EMPTY_STATE.TITLE]: 'Nothing here yet!',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.EMPTY_STATE.DESCRIPTION]: 'Start weaving to bring your ideas to life.',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.EMPTY_STATE.ACTION]: 'Create your first file',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.TITLE]: 'My files',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.SUBTITLE_CREATED]: 'Created {{date}}',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.SUBTITLE_LAST_EDITED]: 'Last edited {{date}}',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.OWNED_BY_YOU]: 'Owned by you',
  [I18N_KEYS.DASHBOARD.PAGES.FILES.RECIPE_CARD.OWNED_BY_OTHER]: 'Owned by {{owner}}',

  [I18N_KEYS.DASHBOARD.PAGES.SHARED_WITH_ME.TITLE]: 'Shared with me',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_WITH_ME.EMPTY_STATE.TITLE]: 'No shared files',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_WITH_ME.EMPTY_STATE.ACTION]: 'Learn more about shared files',

  [I18N_KEYS.DASHBOARD.PAGES.WORKSPACE_FILES.TITLE]: 'Workspace files',
  [I18N_KEYS.DASHBOARD.PAGES.WORKSPACE_FILES.EMPTY_STATE.TITLE]: 'No workspace files',
  [I18N_KEYS.DASHBOARD.PAGES.WORKSPACE_FILES.EMPTY_STATE.ACTION]: 'Learn more about workspace files',

  [I18N_KEYS.DASHBOARD.PAGES.SHARED_APPS.TITLE]: 'Apps shared with me',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_APPS.EMPTY_STATE.TITLE]: 'No design apps',
  [I18N_KEYS.DASHBOARD.PAGES.SHARED_APPS.EMPTY_STATE.ACTION]: 'Learn more about design apps',

  [I18N_KEYS.NAVIGATION_DRAWER.ARCHIVE]: 'Trash',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.TITLE]: 'Trash',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.SUBTITLE]: 'Files and folders moved here are permanently deleted after 30 days.',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE]: 'Restore',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE_ERROR]: 'Failed to restore item',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE_WORKFLOW_SUCCESS]: 'Workflow restored successfully',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.RESTORE_FOLDER_SUCCESS]: 'Folder restored successfully',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.DELETED_AT]: 'Trashed {{date}}',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.DELETED_AT_HEADER]: 'Deleted at',
  [I18N_KEYS.DASHBOARD.PAGES.ARCHIVE.EMPTY_STATE.DESCRIPTION]: 'You don’t have any trashed files.',

  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.TITLE]: 'My Models',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.SUBTITLE]:
    'Library of your favorite models. These models will appear under "My Models" menu in your files. Right-click to edit or delete',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.EMPTY_STATE.TITLE]: 'No models saved yet',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.EMPTY_STATE.DESCRIPTION]:
    'You can import your own models for personal use, or to share with others',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.EMPTY_STATE.ACTION]: 'How to import a model',
  [I18N_KEYS.DASHBOARD.PAGES.MY_MODELS.DELETE_DIALOG_TITLE]: 'Are you sure you want to delete this model?',

  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.TITLE]: 'Public Models',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.SUBTITLE]:
    'Find awesome models that can be used in your files. Right-click to add to your models library',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.MODEL_SAVED]: 'Model saved to your library',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.MODEL_CARD.BASED_ON]: 'Based on:',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.MODEL_CARD.CREATOR]: 'Created by:',
  [I18N_KEYS.DASHBOARD.PAGES.COMMUNITY.CONTEXT_MENU.SAVE_TO_MY_MODELS]: 'Save to My Models',

  [I18N_KEYS.ERROR_PAGE.TITLE]: 'Oops! Something went wrong',
  [I18N_KEYS.ERROR_PAGE.DESCRIPTION]: 'Try to refresh or contact us at <supportEmail>support@weavy.ai</supportEmail>',

  [I18N_KEYS.ERROR_PAGE.RECOVERED_FROM_ERROR]:
    'Successfully recovered from an error.\nPlease contact support if the problem persists.',

  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_3D_MODEL]: 'Failed to deserialize a 3D model',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_FONT]: 'Failed to deserialize a font',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_IMAGE]: 'Failed to deserialize an image',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DESERIALIZE_VIDEO]: 'Failed to deserialize a video',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_IMAGE]: 'Failed to download an image',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_VIDEO]: 'Failed to download a video',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_FONT]:
    'The workflow consists of fonts which are not available in your workspace. Please replace them with available fonts.',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_DOWNLOAD_3D_MODEL]: 'Failed to download a 3D model',
  [I18N_KEYS.FLOW_WARNINGS.FAILED_LOAD_WORKSPACE_CUSTOM_FONTS]:
    'Could not load workspace custom fonts. Workflow text may look wrong.',

  [I18N_KEYS.WEBGL_NOT_SUPPORTED_PAGE.TITLE]: "Looks like your browser doesn't support WebGL 2.0",
  [I18N_KEYS.WEBGL_NOT_SUPPORTED_PAGE.DESCRIPTION]: 'Please make sure WebGL 2.0 is supported by your browser.',

  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.TITLE]: 'GPU driver error',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.DESCRIPTION]: 'Try the steps below to resolve the issue –',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_REFRESH_TITLE]: 'Refresh the page',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_REFRESH_DESCRIPTION]: 'This often resolves the issue immediately.',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_HARDWARE_ACCELERATION_TITLE]: 'Check hardware acceleration',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_HARDWARE_ACCELERATION_DESCRIPTION]:
    'It may be disabled or misconfigured in your browser settings. <learnHow>Learn how</learnHow>',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_RESTART_TITLE]: 'Restart your computer',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_RESTART_DESCRIPTION]:
    'Clears deeper system-level conflicts that may cause errors.',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_CONTACT_SUPPORT_TITLE]: 'Contact support',
  [I18N_KEYS.GPU_DRIVER_ERROR_PAGE.STEP_CONTACT_SUPPORT_DESCRIPTION]:
    'If the problem persists, contact our support team at <supportEmail>support@weavy.ai</supportEmail>.',

  [I18N_KEYS.FIGMA_COMPOSITOR.LOAD_IMAGE_ERROR]: 'Cannot load Figma image preview',
  [I18N_KEYS.FIGMA_COMPOSITOR.ALREADY_CONNECTED_ERROR]: 'Node is already connected to a different Figma compositor.',
  [I18N_KEYS.FIGMA_COMPOSITOR.OPEN_IN_FIGMA]: 'Open in Figma',
  [I18N_KEYS.FIGMA_COMPOSITOR.REFRESH]: 'Refresh',
  [I18N_KEYS.FIGMA_COMPOSITOR.LAYERS]: 'Layers',

  [I18N_KEYS.FLOW_NAVBAR.SHARED_DESIGN_APP_BUTTON]: 'Share Design App',
  [I18N_KEYS.FLOW_NAVBAR.GET_MORE_CREDITS]: 'Get more',
  [I18N_KEYS.FLOW_NAVBAR.GET_MORE_CREDITS_V2]: 'Get more credits',
  [I18N_KEYS.FLOW_NAVBAR.LOW_CREDITS_LABEL]: 'Low credits',

  [I18N_KEYS.GENERAL.CANCEL]: 'Cancel',
  [I18N_KEYS.GENERAL.CLEAR]: 'Clear',
  [I18N_KEYS.GENERAL.CLOSE]: 'Close',
  [I18N_KEYS.GENERAL.CONFIRM]: 'Confirm',
  [I18N_KEYS.GENERAL.COPIED]: 'Copied!',
  [I18N_KEYS.GENERAL.COPY_LINK]: 'Copy link',
  [I18N_KEYS.GENERAL.COPY]: 'Copy',
  [I18N_KEYS.GENERAL.CREDITS]: 'Credits',
  [I18N_KEYS.GENERAL.CREDITS_DISPLAY]: '{{credits}} credits',
  [I18N_KEYS.GENERAL.CREDIT]: 'Credit',
  [I18N_KEYS.GENERAL.DONE]: 'Done',
  [I18N_KEYS.GENERAL.DOWNLOAD]: 'Download',
  [I18N_KEYS.GENERAL.ERROR]: 'An error occurred',
  [I18N_KEYS.GENERAL.FILE]: 'File',
  [I18N_KEYS.GENERAL.FILES]: 'Files',
  [I18N_KEYS.GENERAL.FROM]: 'From',
  [I18N_KEYS.GENERAL.IMAGE]: 'Image',
  [I18N_KEYS.GENERAL.INPUT]: 'Input',
  [I18N_KEYS.GENERAL.INVALID_URL]: 'Invalid URL',
  [I18N_KEYS.GENERAL.MONTH]: 'Month',
  [I18N_KEYS.GENERAL.NAME]: 'Name',
  [I18N_KEYS.GENERAL.OUTPUT]: 'Output',
  [I18N_KEYS.GENERAL.RENAME]: 'Rename',
  [I18N_KEYS.GENERAL.SAVE]: 'Save',
  [I18N_KEYS.GENERAL.SAVING]: 'Saving...',
  [I18N_KEYS.GENERAL.SEARCH]: 'Search',
  [I18N_KEYS.GENERAL.TO]: 'to',
  [I18N_KEYS.GENERAL.UNKNOWN]: 'Unknown',
  [I18N_KEYS.GENERAL.UNKNOWN_ERROR]: 'Something went wrong',
  [I18N_KEYS.GENERAL.UPLOAD_ERROR]: 'Could not upload the file. Please try again.',
  [I18N_KEYS.GENERAL.URL]: 'URL',
  [I18N_KEYS.GENERAL.USER]: 'User',
  [I18N_KEYS.GENERAL.YEAR]: 'Year',
  [I18N_KEYS.GENERAL.LORA_WEIGHT]: 'Weight',
  [I18N_KEYS.GENERAL.YOU]: 'You',
  [I18N_KEYS.GENERAL.ERROR]: 'Error',
  [I18N_KEYS.GENERAL.RELOAD_ALERT_TITLE]: 'A new version of Figma Weave is available',
  [I18N_KEYS.GENERAL.RELOAD_ALERT_CTA]: 'Refresh',
  [I18N_KEYS.GENERAL.PAGE_TITLE]: 'Figma Weave',
  [I18N_KEYS.GENERAL.YES]: 'Yes',
  [I18N_KEYS.GENERAL.NO]: 'No',
  [I18N_KEYS.GENERAL.FILTER]: 'Filter',
  [I18N_KEYS.GENERAL.FILTERS]: 'Filters',
  [I18N_KEYS.GENERAL.RUNNING]: 'Running',
  [I18N_KEYS.GENERAL.COMPLETED]: 'Completed',
  [I18N_KEYS.GENERAL.TYPE]: 'Type',
  [I18N_KEYS.GENERAL.EMAIL]: 'Email',
  [I18N_KEYS.GENERAL.ROLE]: 'Role',
  [I18N_KEYS.GENERAL.COLOR]: 'Color',
  [I18N_KEYS.GENERAL.APPROVE]: 'Approve',
  [I18N_KEYS.GENERAL.ACCEPT]: 'Accept',
  [I18N_KEYS.GENERAL.DELETE]: 'Delete',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_one']: 'Image',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_other']: 'Images',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_lower_one']: 'image',
  [I18N_KEYS.GENERAL.FILE_TYPES.IMAGE + '_lower_other']: 'images',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_one']: 'Video',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_other']: 'Videos',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_lower_one']: 'video',
  [I18N_KEYS.GENERAL.FILE_TYPES.VIDEO + '_lower_other']: 'videos',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_one']: 'Audio file',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_other']: 'Audio files',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_lower_one']: 'audio file',
  [I18N_KEYS.GENERAL.FILE_TYPES.AUDIO + '_lower_other']: 'audio files',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_one']: '3D file',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_other']: '3D files',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_lower_one']: '3D file',
  [I18N_KEYS.GENERAL.FILE_TYPES.THREE_D + '_lower_other']: '3D files',

  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.EDIT]: 'Edit',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.MOVE_TO_TRASH]: 'Move to trash',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.OPEN]: 'Open',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.OPEN_NEW_TAB]: 'Open in a new tab',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.RENAME]: 'Rename',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.MOVE]: 'Move',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CHANGE_OWNER]: 'Change owner',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CREATE_FOLDER]: 'New Folder',
  [I18N_KEYS.MAIN_DASHBOARD.CONTEXT_MENU.CREATE_FILE]: 'New File',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_NEW_FILE]: 'Create New File',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.TITLE]: 'Create folder',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.NAME_LABEL]: 'Name',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.CREATE]: 'Create',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.SUCCESS]: 'Folder created successfully',
  [I18N_KEYS.MAIN_DASHBOARD.CREATE_FOLDER_MODAL.ERROR_PREFIX]: 'Operation failed:',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_CARD.FILE_COUNT_SINGULAR]: '{{count}} file',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_CARD.FILE_COUNT_PLURAL]: '{{count}} files',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.TITLE]: 'Move "{{name}}"',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.CURRENT_LOCATION]: 'Current location',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.CURRENT]: 'Current',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.MOVE]: 'Move',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.SUCCESS_FILE]: 'File moved successfully',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.SUCCESS_FOLDER]: 'Folder moved successfully',
  [I18N_KEYS.MAIN_DASHBOARD.MOVE_MODAL.ERROR_PREFIX]: 'Operation failed:',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.CONFIRMATION_DELETE_APP]: 'Are you sure you want to delete this app?',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.CONFIRM_DELETE]: 'Yes, Delete',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.TITLE]: 'Move to trash',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.MSG]:
    `You're about to move the {{item_type}} <bold>{{item_name}}</bold> to trash.\n\nAnyone with access can restore it from the <bold>Trash</bold> section within 30 days.`,
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_DIALOG.CONFIRM]: 'Move to trash',

  [I18N_KEYS.MAIN_DASHBOARD.DELETE_FOLDER_SUCCESS]: 'Folder deleted successfully',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_FOLDER_ERROR]: 'Failed to delete folder',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_WORKFLOW_SUCCESS]: 'Workflow deleted successfully',
  [I18N_KEYS.MAIN_DASHBOARD.DELETE_WORKFLOW_ERROR]: 'Failed to delete workflow',
  [I18N_KEYS.MAIN_DASHBOARD.RENAME_FOLDER_ERROR]: 'Failed to rename folder',
  [I18N_KEYS.MAIN_DASHBOARD.SEARCH_NO_RESULTS.TITLE]: 'No results for: "{{searchTerm}}"',
  [I18N_KEYS.MAIN_DASHBOARD.SEARCH_NO_RESULTS.DESCRIPTION]: 'Try searching for something else',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_EMPTY.TITLE]: 'This folder is empty',
  [I18N_KEYS.MAIN_DASHBOARD.FOLDER_EMPTY.DESCRIPTION]: 'Create new files or move files here from other folders',

  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.WORKFLOWS]: 'Workflow library',
  [I18N_KEYS.MAIN_DASHBOARD.EDUCATION_GALLERY.TUTORIALS]: 'Tutorials',
  [I18N_KEYS.MAIN_DASHBOARD.ERROR_LOADING_WORKFLOWS.TITLE]: 'Oops! Something went wrong',
  [I18N_KEYS.MAIN_DASHBOARD.ERROR_LOADING_WORKFLOWS.ACTION]: 'Reload Page',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.PLAN]: 'Plan',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CREDITS]: 'Credits',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.TEAM_CREDITS]: 'Workspace Credits',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CTA_CREDITS]: 'Get more',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CTA_CREDITS_FREE]: 'Upgrade for more',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.CTA_PLAN]: 'Upgrade',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.TEAM_HINT_CREDITS_EMPTY]:
    'Not enough credits to run models. Contact your workspace admin.',
  [I18N_KEYS.MAIN_DASHBOARD.USERMENU.MENU_ITEM_SETTINGS]: 'Settings',
  [I18N_KEYS.MAIN_DASHBOARD.WORKSPACES_MENU.TITLE]: 'Switch workspace',

  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.TITLE]: 'Change ownership',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SUBTITLE]: 'Assign a new owner to this file to allow them to edit it.',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SELECT_OWNER]: 'Select owner',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.CANCEL]: 'Cancel',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.CONFIRM]: 'Change owner',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.CONFIRM_LOADING]: 'Changing',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.SUCCESS_SNACKBAR]: 'Owner changed successfully',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.WARNING]: 'You will no longer be able to edit this file.',
  [I18N_KEYS.MAIN_DASHBOARD.CHANGE_OWNER_MODAL.ERROR_SNACKBAR]: 'Failed changing owner.',

  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.DISCORD_BUTTON]: 'Join our community on Discord',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.FOOTER_TEXT]: 'In the meantime...',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.SUBTITLE]:
    'Open <url>Figma Weave</url> on desktop to start building your design machine.',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.TITLE]: 'Your \nmasterpiece \nneeds a bigger \ncanvas',
  [I18N_KEYS.MOBILE_UNSUPPORTED_PAGE.YOUTUBE_INTRO_BUTTON]: 'Watch a 2-minute intro on YouTube',

  [I18N_KEYS.NAVIGATION_DRAWER.BUY_MORE]: 'Buy More',
  [I18N_KEYS.NAVIGATION_DRAWER.NEW_FILE]: 'New File',
  [I18N_KEYS.NAVIGATION_DRAWER.NEW_FOLDER]: 'New Folder',
  [I18N_KEYS.NAVIGATION_DRAWER.CREATE_NEW_FILE]: 'Create New File',
  [I18N_KEYS.NAVIGATION_DRAWER.MY_FILES]: 'My Files',
  [I18N_KEYS.NAVIGATION_DRAWER.FAVORITES]: 'Favorites',
  [I18N_KEYS.NAVIGATION_DRAWER.SHARED_WITH_ME]: 'Shared with me',
  [I18N_KEYS.NAVIGATION_DRAWER.WORKSPACE_FILES]: 'Workspace Files',
  [I18N_KEYS.NAVIGATION_DRAWER.APPS]: 'Apps',
  [I18N_KEYS.NAVIGATION_DRAWER.MODELS_SECTION]: 'Models',
  [I18N_KEYS.NAVIGATION_DRAWER.MODELS]: 'My Models',
  [I18N_KEYS.NAVIGATION_DRAWER.COMMUNITY]: 'Community',
  [I18N_KEYS.NAVIGATION_DRAWER.DISCORD_TITLE]: 'Join our Discord',
  [I18N_KEYS.NAVIGATION_DRAWER.DISCORD_CTA]: 'Discord',

  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.LOCK]: 'Lock Camera',
  [I18N_KEYS.NODE_IMAGE_LIST.CAMERA_CONTROLS.UNLOCK]: 'Unlock Camera',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.DOWNLOAD]: 'Download',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.SET_AS_COVER]: 'Set as cover',
  [I18N_KEYS.NODE_IMAGE_LIST.CONTEXT_MENU.COPY_IMAGE]: 'Copy image',
  [I18N_KEYS.NODE_IMAGE_LIST.DELETE_ALL]: 'Delete all',
  [I18N_KEYS.NODE_IMAGE_LIST.DELETE_ALL_OTHERS]: 'Delete all others',
  [I18N_KEYS.NODE_IMAGE_LIST.DELETE_CURRENT]: 'Delete current',
  [I18N_KEYS.PAYMENTS.CREDITS_SUCCESS_MESSAGE]: '<amount/> Credits added successfully!',
  [I18N_KEYS.PAYMENTS.UPGRADE_SUCCESS_MESSAGE]: 'Your plan has been upgraded to <plan/> successfully!',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_SUCCESS_MESSAGE]: 'Your plan has been updated to <plan/> successfully.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TITLE]: 'Choose the best plan for you',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.ALL_PACKAGES_INCLUDE]: 'All plans will provide you with',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.INCLUDED_FEATURE_01]: 'Full access to all AI models',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.INCLUDED_FEATURE_02]: 'Professional editing tools',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.SUBTITLE.INCLUDED_FEATURE_03]: 'Commercial license',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TEMP_TITLE]: 'Flexible pricing for your needs',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.MONTHLY]: 'Monthly',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.TOGGLE_BUTTON.YEARLY]: 'Annually - 20%',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CURRENT_PLAN_CTA]: 'Current Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.UPGRADE_CTA]: 'Upgrade',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CHANGE_PLAN_CTA]: 'Change Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FREE_PLAN_CTA]: 'Start Free',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PAID_PLAN_CTA]: 'Get This Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PAID_ANNUAL_PLAN_CTA]: 'Get Annual Plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.DOWNGRADE_DATE_PREFIX]: 'Starting on',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RESTORE_PLAN]: 'Restore current plan',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.RESTORE_CONFIRMATION_TITLE]: 'Are you sure you want to restore your plan?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.CREDITS_TABLE_TITLE]:
    "See exactly what you can produce with each plan's monthly credits",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.PARTNERS_TITLE]: 'Empowering production grade creative work at:',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQ_TITLE]: 'Frequently Asked Questions',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.COMING_SOON]: 'Coming soon',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.MOST_POPULAR]: 'Most popular',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.GAIN_20_PERCENT]: 'Gain 20%',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_1.QUESTION]: 'How do Figma Weave credits work?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_1.ANSWER]:
    'Figma Weave credits are your currency for AI generation. Each plan includes a monthly credit allocation that you spend when creating content with different AI models. Different models require different amounts of credits per generation - for example, running Flux costs fewer credits than using Veo. See the full list <link/>.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_2.QUESTION]: 'What happens if I use all my monthly credits?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_2.ANSWER]:
    "For paid plans (Starter, Professional, and Team), you can purchase additional credits at $10 per 1,000 credits (Starter) or $10 per 1,200 credits (Professional and Team). These topped-up credits roll over for 12 months, giving you flexibility beyond your monthly allocation. The Free plan doesn't offer credit top-ups.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_3.QUESTION]: 'Do unused credits roll over to the next month?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_3.ANSWER]:
    'If you’re on a Professional or Team plan, your base monthly credits roll over to the next month - as long as your subscription stays active. You can accumulate up to 3x your monthly credit amount. After that, any unused credits above the limit will expire. Starter and Free plans don’t include rollover. Any additional credits purchased through top-ups continue to roll over for 12 months from the purchase date.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_4.QUESTION]:
    'Can I use Figma Weave creations for client work and commercial projects?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_4.ANSWER]:
    "Absolutely! We offer one of the most advanced commercial rights policies in the industry. Figma Weave as a platform provides full commercial rights and we never train on your work. Most models available through our platform are cleared for commercial use and don't train on customer data.\nAs an open platform, we also give you access to cutting-edge models that may have different terms. We negotiate the best legal and commercial terms available with all providers for your benefit. For complete transparency, check our <link/> in our Trust Center to see commercial rights status for each model.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_5.QUESTION]: 'How does Figma Weave handle my data and creations?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_5.ANSWER]:
    "Your creative work stays yours. We don't use your images or prompts to train our platform. We implement strict data standards and security measures to protect your content. We only collect essential data to provide our services and anonymous metadata about workflows to improve recommendations.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_6.QUESTION]: "What is Figma Weave's refund and cancellation policy?",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_6.ANSWER]:
    "You can cancel your subscription at any time through your account settings or by contacting our support team. Your subscription will remain active until the end of your current billing period. We don't provide prorated refunds for partial months of service.\nIf you're not satisfied with your subscription within the first 7 days after signing up, contact our support team for a refund evaluation.",
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_7.QUESTION]: 'Does Figma Weave provide workshops and training?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_7.ANSWER]:
    'Yes! We provide free office hours, a comprehensive VOD library of educational content, and a template library filled with incredible workflows to jumpstart your creative process. Enterprise clients get team training sessions. Contact us directly if you have a specific training or educational need.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_8.QUESTION]: 'Can I control how my team uses credits?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_8.ANSWER]:
    'Yes! With the Team plan, you get access to our Credits Management system. Set a monthly default or custom allocation per user, track usage in real time, and stay in control.',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_9.QUESTION]: 'Still have questions?',
  [I18N_KEYS.PAYMENTS.PRICING_TABLE.FAQS.FAQ_9.ANSWER]:
    "We're here to help! Reach out to us at <link/> and our team will get back to you promptly.",
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.TITLE]: 'Confirm upgrade',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PROCESSING]: 'Processing',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.PLAN_DESCRIPTION]: 'Figma Weave <plan/> subscription',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.CHANGE_PAYMENT_METHOD]: 'Change',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.ERROR_MESSAGE]:
    'Something went wrong. Please try again. If the problem continues, <link/>',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.ERROR_MESSAGE_LINK]: 'contact our support team',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.BILLING_CYCLE_INFO]: 'Billed <billingCycle/>, starting today',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.CTA_CONFIRM]: 'Pay now',
  [I18N_KEYS.PAYMENTS.UPGRADE_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.TITLE]: 'Confirm plan change',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.PLAN_CHANGE_MESSAGE]:
    "You're about to downgrade to the <plan/> plan. Your current plan will remain active until the end of your billing period.",
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.CTA_CONFIRM]: 'Downgrade',
  [I18N_KEYS.PAYMENTS.DOWNGRADE_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.TITLE]: 'Purchase additional credits',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.CTA_CONFIRM]: 'Pay now',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.EQUALS]: 'Equals to',
  [I18N_KEYS.PAYMENTS.GET_MORE_CREDITS_MODAL.MIN_PRICE_ERROR]: 'Minimum price is ${{minPrice}}',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.TITLE]: 'Get more credits',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.SUBTITLE]: 'Choose one of the following options -',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CREDITS.TITLE]: 'Buy more credits',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CREDITS.SUBTITLE]: 'Purchase additional credits for immediate use',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_PRICING.TITLE]: 'Upgrade your plan',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_PRICING.SUBTITLE]: 'Get more credits monthly',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CONFIRM]: 'Continue',
  [I18N_KEYS.PAYMENTS.CREDITS_OR_PRICING_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.TITLE]: 'How many people are on your team?',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.SUBTITLE]:
    'Select the number of people on your team. Each seat costs ${{pricePerSeat}} / {{billingCycle}}.',
  [I18N_KEYS.PAYMENTS.TEAM_SIZE_MODAL.CTA_CONFIRM]: 'Continue',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.TITLE]: 'Looking for an enterprise solution?',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.SUBTITLE]: 'Our Enterprise plan contains everything in Team plus:',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.CTA]: 'Contact us',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_CUSTOM_CREDITS]: 'Custom credit allocation',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_TEAM_TRAINING]: 'Team training',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_PREMIUM_SUPPORT]: 'Premium customer support on Slack',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_OWN_API_KEYS]: 'Your own API keys',
  [I18N_KEYS.PAYMENTS.ENTERPRISE_PACKAGE.FEATURE_API_WORKFLOWS]: 'Run workflows through API - coming soon',

  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ADD_NODES_CONTENT]:
    'Drag and drop the "Flux Fast" node from the menu to your canvas.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ADD_NODES_TITLE]: 'Add a model',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_CONTENT]:
    "We'll tailor our instructions to work best with your device.",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_CTA_MOUSE]: 'Mouse',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_CTA_TRACKPAD]: 'Trackpad',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CHOOSE_PREFERENCE_TITLE]: 'What are you using?',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CONNECT_NODES_CONTENT]:
    'Click and drag from the output handle of the Prompt node, to the input handle of the "Flux Fast" node.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.CONNECT_NODES_TITLE]: 'Connect the nodes',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.DROP_NODE_HERE]: 'Drop here',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_CONTENT]:
    "You've just created your first image with Figma Weave. Ready to explore more?",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_CTA_CONTINUE]: 'Continue to the next tutorial',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_CTA_STOP]: 'Start working on this workflow',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.FINISH_TOUR_TITLE]: 'Amazing work!',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.PAN_CONTENT + '_mouse']:
    'Hold Spacebar and left click and drag to pan.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.PAN_CONTENT + '_trackpad']: 'Use two fingers to pan.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.PAN_TITLE]: 'Move to center the yellow circles',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.RUN_MODEL_CONTENT]:
    'Click the "Run Model" button to execute your workflow.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.RUN_MODEL_TITLE]: 'Generate your first image',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.SHOW_NODE_CONTENT]:
    'This is a Prompt node. It holds the text prompt that guides your AI image generation.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.SHOW_NODE_TITLE]: 'Meet your first node',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.WELCOME_CONTENT]:
    "You're about to learn how to create your first workflow - a simple text to image generation.",
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.WELCOME_TITLE]: 'Welcome to the Figma Weave Editor',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ZOOM_CONTENT + '_mouse']:
    'Hold cmd/ctrl and scroll mouse wheel to zoom.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ZOOM_CONTENT + '_trackpad']: 'Pinch two fingers to zoom.',
  [I18N_KEYS.PRODUCT_TOURS.FLOW.NAVIGATION_TOUR.ZOOM_TITLE]: 'Zoom in to fit the node into the box',
  [I18N_KEYS.PRODUCT_TOURS.NEXT_STEP]: 'Next',
  [I18N_KEYS.PRODUCT_TOURS.PREVIOUS_STEP]: 'Back',
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_CANCEL]: 'Continue Learning',
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_CTA]: 'Exit Anyway',
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_MESSAGE]:
    "Your progress in this tutorial won't be saved. Are you sure you want to quit?",
  [I18N_KEYS.PRODUCT_TOURS.QUIT_TOUR_CONFIRMATION_TITLE]: 'Exit Tutorial?',
  [I18N_KEYS.PRODUCT_TOURS.START_OF_TOUR.SKIP]: 'Skip for Now',
  [I18N_KEYS.PRODUCT_TOURS.START_OF_TOUR.START_NOW]: 'Start Tutorial',
  [I18N_KEYS.PRODUCT_TOURS.TOUR_STEP_INDICATION]: '{{step}} of {{total}}',

  [I18N_KEYS.RECIPE_MAIN.ERRORS.DOWNLOAD_FAILED]: 'Download failed',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.DOWNLOAD_FAILED_MULTIPLE]: 'Download failed for multiple files',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.DOWNLOAD_SIZE_EXCEEDED]: 'Selected files are {{size}}, exceeding the {{limit}} limit',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.CLEAR_CONTENT_FAILED]: 'Failed to clear content. Please try again.',
  [I18N_KEYS.RECIPE_MAIN.DOWNLOAD_PREPARING]: 'Preparing download... {{percent}}%',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.NO_RECIPE_ACCESS.TITLE]: 'No access to this page',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.NO_RECIPE_ACCESS.DESCRIPTION]: 'Please ask the owner to share the page with you.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.NO_RECIPE_ACCESS.ACTION]: 'Back to dashboard',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.GENERAL.MESSAGE]: 'An error occurred while saving.',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.GENERAL.ACTION]: 'Try again',
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.CONFLICT.MESSAGE]:
    "Oops... You're viewing an old version of this workflow. Refresh to see the latest version.",
  [I18N_KEYS.RECIPE_MAIN.ERRORS.SAVE_ERRORS.CONFLICT.ACTION]: 'Refresh',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CANNOT_DELETE_GROUP_WITH_LOCKED_NODES]:
    'Cannot delete group because it contains locked nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.OUTPUTS]: 'Outputs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.ADD_OUTPUT]: 'Add output',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EMPTY_NO_OUTPUTS_LINE_1]: 'No outputs added yet.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.APP_BUILDER_RIGHT_PANEL.EMPTY_NO_OUTPUTS_LINE_2]:
    'Click the button to add your first output.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.FLOW_NAVBAR.READ_ONLY]: 'Read Only',
  [I18N_KEYS.RECIPE_MAIN.FLOW.FLOW_NAVBAR.SAVING]: 'Saving',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DELETE_ALL_GENERATIONS]: 'Remove all generations',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DELETE_ALL_OTHERS_GENERATIONS]: 'Remove all other generations',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DELETE_CURRENT_GENERATION]: 'Remove current generation',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_CURRENT]: 'Download current',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.DOWNLOAD_BATCH]: 'Download batch',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.OPEN_IN_GALLERY]: 'Open in gallery',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.SET_AS_COVER]: 'Set as cover image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.HIDE_INFO]: 'Hide Info',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.NEGATIVE_PROMPT]: 'Negative Prompt',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.PARAMETERS]: 'Parameters',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.MODEL]: 'Model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.PROMPT]: 'Prompt',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.NO_PREVIEW]: 'No preview available',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.SHOW_INFO]: 'Show Info',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.SHOW_MORE]: 'Show more',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.SHOW_LESS]: 'Show less',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.REFERENCE_IMAGE + '_one']: 'Reference Image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GALLERY.PARAMS.REFERENCE_IMAGE + '_other']: 'Reference Images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_EDITOR]: 'Back to latest version',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_READER]: 'Duplicate to My Files',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.CTA_GUEST]: 'Sign in',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.TITLE_SINGLE]: 'Delete group',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.TITLE_PLURAL]: 'Delete groups',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.MESSAGE_SINGLE]:
    'Are you sure you want to delete {{groupName}}?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.MESSAGE_PLURAL]:
    'Are you sure you want to delete these {{count}} groups?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.CTA_CONFIRM]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GROUP.DELETE_GROUP_CONFIRMATION.CHECKBOX_LABEL]: "Don't show this again",
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_ALL_CONTENT_CONFIRMATION.TITLE]: 'Clear all content?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_ALL_CONTENT_CONFIRMATION.MESSAGE]:
    'This will remove all content from selected nodes.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_ALL_CONTENT_CONFIRMATION.CHECKBOX_LABEL]: "Don't show this again",
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_OTHER_CONTENT_CONFIRMATION.TITLE]: 'Clear other content?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_OTHER_CONTENT_CONFIRMATION.MESSAGE]:
    'This will keep only the selected content in each node and remove the rest.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.CLEAR_OTHER_CONTENT_CONFIRMATION.CHECKBOX_LABEL]: "Don't show this again",

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.BACK_TO_DASHBOARD]: 'Back to files',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.CREATE_NEW_FILE]: 'New file',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.OPEN_RECENT]: 'Open recent',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.DUPLICATE_FILE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.USE_WHEEL_TO_ZOOM]: 'Use scroll wheel zoom',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.RIGHT_CLICK_TO_OPEN_MENU]: 'Right-click to open menu',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.REQUIRE_ALT_KEY_FOR_SUGGESTIONS]:
    '{{key}}+drag for node suggestions',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.SHARE_WORKFLOW]: 'Share',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.RENAME_WORKFLOW]: 'Rename',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.KEYBOARD_SHORTCUTS]: 'Keyboard shortcuts',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.PREFERENCES]: 'Preferences',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.SNAP_TO_GRID]: 'Snap to grid',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE]: 'Wire style',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_BEZIER]: 'Bezier',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_STEP]: 'Elbow',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.MAIN_MENU.EDGE_STYLE_LINE]: 'Line',
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.TITLE_EDITOR]:
    "You're viewing a previous version of this workflow",
  [I18N_KEYS.RECIPE_MAIN.FLOW.GENERAL.READ_ONLY_PANEL.TITLE_READER]:
    "You're viewing a read-only version of this workflow",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MEDIA_LIBRARY.NO_MEDIA]: 'No media found. Yet...',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MODELS.COMMUNITY_MODELS]: 'Community models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MODELS.MY_MODELS]: 'My models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.TOOLBOX.MOST_USED]: 'Most used',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.TITLE]: 'Saved',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.NODES]: 'Nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.SUBFLOWS]: 'Subflows',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.COMING_SOON]: 'Coming soon',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.NODES_EMPTY]:
    "Save nodes to reuse them across workflows. Select 'Save node' from the node's context menu.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.MODELS_EMPTY]:
    "Save models to reuse them across workflows. Select 'Save model' from the model's context menu.",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_TOOLTIP]: 'Edit',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DONE]: 'Done',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_DIALOG_TITLE]: 'Edit <{{name}}>',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_SAVE]: 'Save',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_SUCCESS]: '{{type}} updated successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.EDIT_ERROR]: 'Failed to update {{type}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_TITLE]: 'Delete <{{name}}>?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_MESSAGE]: 'This cannot be undone.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_CONFIRM]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_DONT_SHOW]: "Don't show this again",
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_MODEL_SUCCESS]: 'Model deleted successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_NODE_SUCCESS]: 'Node deleted successfully',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_MODEL_ERROR]: 'Failed to delete model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.WORKSPACE_ASSETS.DELETE_NODE_ERROR]: 'Failed to delete node',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.SEARCH.EMPTY]: 'No results match this search',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NEW_INDICATOR]: 'New',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.VERIFIED_BY_FIGMA]: 'Verified by Figma',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.UNVERIFIED_DISCLAIMER_WITH_ADDITIONAL_TERMS]:
    'This model is unverified. Your use of this model is subject to its <additionalTermsLink>API Service Terms</additionalTermsLink>, <termsLink>Terms</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.UNVERIFIED_DISCLAIMER]:
    'This model is unverified. Your use of this model is subject to its <termsLink>Terms</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.BASED_ON]: 'Based on {{name}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.CREATED_BY]: 'Created by {{name}}',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.NODE_DETAILS.CREATED_BY_ME]: 'Created by me',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.RECENT]: 'Recent',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.TOOLS]: 'Tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.IMAGE_MODELS]: 'Image models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.VIDEO_MODELS]: 'Video models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.THREE_D_MODELS]: '3D models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.CUSTOM_MODELS]: 'Custom models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.FREQUENTLY_USED]: 'Frequently used',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.DATA_TYPES]: 'Datatypes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.NON_MODEL_EDIT]: 'Editing',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.MATTING]: 'Matte',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.LIP_SYNC]: 'Lip sync',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.ITERATORS]: 'Iterators',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.TEXT_TOOLS]: 'Text tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.TEXT_ITERATOR.DISPLAY_NAME]: 'Text Iterator',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.TEXT_ITERATOR.DESCRIPTION]:
    'Iterate over a list of text values',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.IMAGE_ITERATOR.DISPLAY_NAME]: 'Image Iterator',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.IMAGE_ITERATOR.DESCRIPTION]:
    'Iterate over a list of images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.VIDEO_ITERATOR.DISPLAY_NAME]: 'Video Iterator',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.ITERATOR_MENU_ITEMS.VIDEO_ITERATOR.DESCRIPTION]:
    'Iterate over a list of videos',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED]: 'Saved',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED_MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.SAVED_NODES]: 'Nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.HELPERS]: 'Helpers',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_IMAGE_FROM_TEXT]: 'Generate from text',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_VECTOR_FROM_TEXT]: 'Generate vector graphics',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.EDIT_IMAGE]: 'Edit images',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_IMAGE_FROM_IMAGE]: 'Generate from image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.ENHANCE_IMAGE]: 'Enhance images',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_VIDEO_FROM_TEXT_OR_IMAGE]: 'Generate from text or image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_VIDEO_FROM_VIDEO]: 'Generate from video',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.ENHANCE_VIDEO]: 'Enhance videos',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.GENERATE_3D_FROM_TEXT_OR_IMAGE]: 'Generate from text or image',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.USER_MODELS]: 'My models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.MENU_TITLES.COMMUNITY_MODELS]: 'Community models',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.LABEL]: 'Order',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.FEATURED]: 'Featured',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.PRICE_ASC]: 'Price: low to high',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.ORDERBY.PRICE_DESC]: 'Price: high to low',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.ALL]: 'All',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.TOOLS]: 'Tools',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.MODELS]: 'Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.VERIFIED]: 'Verified',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_PANEL.FILTERS.MODE_TOGGLE.UNVERIFIED]: 'Unverified',

  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.RECENT]: 'Quick access',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.TOOLBOX]: 'Toolbox',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.IMAGE]: 'Image Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.VIDEO]: 'Video Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.THREEDEE]: '3D Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.MY_MODELS]: 'My Models and Community Models',
  [I18N_KEYS.RECIPE_MAIN.FLOW.LEFT_TOOLS_PANEL.TITLE.MEDIA]: 'Assets',

  [I18N_KEYS.RECIPE_MAIN.FLOW.WORKFLOW]: 'Canvas',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DESIGN_APP]: 'App',

  [I18N_KEYS.RECIPE_MAIN.FLOW.CREDITS_INFO_CREDITS]: '{{credits}} credits',
  [I18N_KEYS.RECIPE_MAIN.FLOW.SHARE]: 'Share',

  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_IN]: 'Zoom in',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_OUT]: 'Zoom out',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_TO_HUNDRED]: 'Zoom to 100%',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ACTIONS.ZOOM_TO_FIT]: 'Zoom to fit',

  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_LABEL]: 'API key',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.BYOK_TOOLTIP]: 'Runs using your workspace API key',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.NUM_OF_MODELS]: '{{count}} Nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.SET_AS_INPUT]: 'Set as input',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.SET_AS_PARAMETER]: 'Set as parameter',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.ADD_LIST_ITEM]: 'Add another',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.MODEL_PROPERTIES.LIST_ITEM_PLACEHOLDER]: 'List item',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.TITLE]: 'Run selected nodes',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.RUNS]: 'Runs',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.CTA]: 'Run selected',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.UNSUPPORTED_NODES_INFO + '_one']:
    'Running a {{nodes}} node is not supported',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.UNSUPPORTED_NODES_INFO + '_other']:
    'Running {{nodes}} nodes is not supported',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.ALREADY_RUNNING_INFO]:
    'Cannot run selected nodes as some are already running',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.NOT_ENOUGH_CREDITS]:
    'Not enough credits to run the selected models.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.NOT_ENOUGH_CREDITS_TEAM]:
    'Not enough credits to run the selected models. Please contact your account admin',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.NOT_ENOUGH_CREDITS_INDIVIDUAL]:
    'Not enough credits to run the selected models. Buy more credits',
  [I18N_KEYS.RECIPE_MAIN.FLOW.DRAWER.RUN_MODELS_SECTION.ITERATORS_INFO.TITLE]: 'Iterators',
  [I18N_KEYS.RECIPE_MAIN.FLOW.SUGGESTION_MENU.DROP_INDICATION]: '+ Drop to add node',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.TITLE]: 'High cost model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.SUBTITLE]:
    'You are about to run <b>{{displayName}}</b> that costs <icon/><b>{{modelPrice}} credits</b> per run. Are you sure you want to continue?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.CHECKBOX_LABEL]: 'Don’t show this warning again for this model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.MODEL_NAME_PLACEHOLDER]: 'a model',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.CTA_CONFIRM]: 'Run anyway',
  [I18N_KEYS.RECIPE_MAIN.FLOW.PRICY_MODEL_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.DIALOG.TITLE]: 'Unable to calculate cost',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.DIALOG.MSG]:
    'A text iterator receives input from an LLM node, which means the number of iterations - and final cost - depends on the execution.\n\nDo you want to run it anyway?',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.DIALOG.CONFIRM_BTN_TEXT]: 'Run anyway',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.PRICE_TEXT]: 'Unknown',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNKNOWN_COST.TOOLTIP]:
    'A text iterator receives input from an LLM node, which means the number of iterations - and final cost - depends on the execution.',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.VALUES + '_one']: '{{count}} value',
  [I18N_KEYS.RECIPE_MAIN.FLOW.ITERATORS_SECTION.VALUES + '_other']: '{{count}} values',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TITLE]: "Model provider's terms notice",
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG_IMPORTED_MODEL.TITLE]: 'Import model notice',
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TEXT]:
    `{{modelsList}} is an independent third-party model, not controlled by Figma Weave. This unverified model is governed by its own terms and policies, which cover things like how your data is used and protected.\n\nBy clicking "Accept", you accept the model provider's <termsUrl>Terms</termsUrl> and <privacyPolicyUrl>Privacy Policy</privacyPolicyUrl> enabling the use of this and any additional models governed by these same terms`,
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TEXT + '_additionalTermsLink']:
    `{{modelsList}} is an independent third-party model, not controlled by Figma Weave. This unverified model is governed by its own terms and policies, which cover things like how your data is used and protected.\n\nBy clicking "Run model", you accept the model provider's <termsUrl>Terms</termsUrl>, <additionalTermsLink>API Terms</additionalTermsLink> and <privacyPolicyUrl>Privacy Policy</privacyPolicyUrl> enabling the use of this and any additional models governed by these same terms`,
  [I18N_KEYS.RECIPE_MAIN.FLOW.UNVERIFIED_MODEL_RUN.DIALOG.TEXT + '_noterms']:
    `Heads up — you imported {{modelsList}} from outside Figma Weave.\n\nBy continuing and clicking "Accept," you take full responsibility for your use of it, including that you are allowed to use it and that it fits your needs.`,

  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.GENERAL]: 'Deprecated',
  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.EDIT]: 'The Photopea editor is no longer supported.',
  [I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.COMPV2]:
    'This version of the Compositor node is no longer supported. Please use the new Compositor node instead.',
  [I18N_KEYS.RECIPE_MAIN.NODES.SHARED.NODE_DETAILS_ACCORDION.TITLE]: 'Tool Details',
  [I18N_KEYS.RECIPE_MAIN.NODES.SHARED.SHOW_MORE_CHIP.SHOW_MORE]: 'Show more',
  [I18N_KEYS.RECIPE_MAIN.NODES.SHARED.SHOW_MORE_CHIP.SHOW_LESS]: 'Show less',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXPORT.EXPORT_CTA]: 'Export',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXPORT.EXPORT_CTA_RENDERING]: 'Rendering',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.CLICK_TO_UNLOCK]: 'Click to unlock',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.CLICK_TO_UNLOCK_GROUP]: 'Click to unlock group',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.THIS_NODE_IS_LOCKED]: 'This node is locked',
  [I18N_KEYS.RECIPE_MAIN.NODES.LOCKED.THIS_NODE_IS_LOCKED_GROUP]: 'This node is in a locked group',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.ADD_LORA]: '+ Add another LoRA',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.LORAS]: 'LoRAs List',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.SELECT_LORA]: 'Select a LoRA',
  [I18N_KEYS.RECIPE_MAIN.NODES.MULTI_LORA.NO_OPTIONS]: 'No LoRAs',

  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE_ALL_UPLOADS]: 'Remove all',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE_ALL_OTHERS_UPLOADS]: 'Remove all but current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DELETE_CURRENT_UPLOAD]: 'Remove current',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.LOCK]: 'Lock',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.RENAME]: 'Rename',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.UNLOCK]: 'Unlock',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.UNLOCK_GROUP_FIRST]: 'Group is locked',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE]: 'View',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.REMOVE_FROM_GROUP]: 'Remove from group',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE_SINGLE]: 'Single',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE_BATCH]: 'Batch',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.VIEW_MODE_ALL]: 'All',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_NODE]: 'Save node',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_NODE_SUCCESS]: 'Node saved successfully',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_NODE_ERROR]: 'Failed to save node',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_MODEL]: 'Save model',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_MODEL_SUCCESS]: 'Model saved successfully',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.SAVE_MODEL_ERROR]: 'Failed to save model',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.UNPACK]: 'Unpack',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_ITERATOR]: 'Create iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_IMAGE_ITERATOR]: 'Create image iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_VIDEO_ITERATOR]: 'Create video iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU.CREATE_TEXT_ITERATOR]: 'Create text iterator',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.CANCEL_TEXT]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.CONFIRM_TEXT]: 'Yes, Remove',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.MESSAGE]:
    'Are you sure you want to remove all generations?',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_MENU_CONFIRMATION_DIALOG.DELETE_ALL_UPLOADS_MESSAGE]:
    'Are you sure you want to remove all files uploads?',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.PLACEHOLDER]: 'Connect multiple prompts to one output prompt.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.ADDITIONAL_TEXT_PLACEHOLDER]: 'Write additional text',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_CONCAT.ADD_ANOTHER_TEXT_INPUT]: '+ Add another text input',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.PLACEHOLDER]: 'Your prompt goes here...',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.TRUNCATED_WARNING]:
    'Prompt is too long. Truncated to {{max}} characters.',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.ADD_VARIABLE]: 'Add variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.CREATE_VARIABLE]: 'Create variable',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_MODE]: 'Display',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_SOURCE_VALUE]: 'Source + Value',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_VALUE]: 'Value',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.DISPLAY_SOURCE]: 'Source',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.TAG_CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.TAG_CONTEXT_MENU.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V3.EDITOR_CONTEXT_MENU.PASTE]: 'Paste here',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V2.PROMPT_LABEL]: 'Prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V2.NEGATIVE_PROMPT_LABEL]: 'Negative Prompt',
  [I18N_KEYS.RECIPE_MAIN.NODES.PROMPT_NODE_V2.NEGATIVE_PROMPT_PLACEHOLDER]: 'Your negative prompt goes here...',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.PLACEHOLDER]: 'Type...',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE]: 'Font Size',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE_OPTIONS.SMALL]: 'Small',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE_OPTIONS.MEDIUM]: 'Medium',
  [I18N_KEYS.RECIPE_MAIN.NODES.STICKY_NOTE.CONTEXT_MENU.FONT_SIZE_OPTIONS.LARGE]: 'Large',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.PLACEHOLDER]: 'Paste replicate.com, fal.ai, or civitai.com URL',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.INPUT_ERROR]: 'Could not find model',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_CTA]: 'Save model to my library',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.ADDED_TO_MY_LIBRARY]: 'Added to your library',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.TITLE]: 'Save model to my library',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.SUBTITLE]: 'Give your model a name and description',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.NAME_LABEL]: 'Model name*',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.NAME_PLACEHOLDER]: 'Meaningful name',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.DESCRIPTION_LABEL]: 'Description*',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.DESCRIPTION_PLACEHOLDER]: 'Clear description',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.CTA_SAVE]: 'Save model',
  [I18N_KEYS.RECIPE_MAIN.NODES.WILDCARD.SAVE_TO_MY_LIBRARY_DIALOG.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPOSITOR.EDIT_CTA]: 'Edit',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPOSITOR.ADD_ANOTHER_LAYER_CTA]: '+ Add another layer',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.BACKGROUND_COLOR_LABEL]: 'Background Color',
  [I18N_KEYS.RECIPE_MAIN.NODES.PAINTER.BRUSH_SIZE_LABEL]: 'Size',

  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.LOCK_ASPECT_RATIO]: 'Lock aspect ratio',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.RESET]: 'Reset',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.DIMENSIONS]: 'Dimensions',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.ASPECT_RATIO]: 'Aspect ratio',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.CUSTOM_ASPECT_RATIO]: 'Custom',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.WIDTH_LETTER]: 'W',
  [I18N_KEYS.RECIPE_MAIN.NODES.CROP.HEIGHT_LETTER]: 'H',

  [I18N_KEYS.RECIPE_MAIN.NODES.RESIZE.UNSUPPORTED_FILE]: 'Unsupported file',
  [I18N_KEYS.RECIPE_MAIN.NODES.NUMBER.IS_FLOAT]: 'Use decimals (float)',
  [I18N_KEYS.RECIPE_MAIN.NODES.NUMBER.MIN]: 'Min',
  [I18N_KEYS.RECIPE_MAIN.NODES.NUMBER.MAX]: 'Max',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.ADD_ITEM]: '+ Add another item',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.SPLIT_TEXT_BY]: 'Split text by:',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.PLACEHOLDER]: 'Array item',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.ITEMS_COUNT + '_one']: '{{count}} item',
  [I18N_KEYS.RECIPE_MAIN.NODES.ARRAY.ITEMS_COUNT + '_other']: '{{count}} items',
  [I18N_KEYS.RECIPE_MAIN.NODES.TOGGLE.TRUE]: 'True',
  [I18N_KEYS.RECIPE_MAIN.NODES.TOGGLE.FALSE]: 'False',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.RED]: 'Red',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.GREEN]: 'Green',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.BLUE]: 'Blue',
  [I18N_KEYS.RECIPE_MAIN.NODES.CHANNEL.ALPHA]: 'Alpha',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.MASK]: 'Mask',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.ERROR]:
    'Error analyzing masks. Please check inputs or contact us if the problem persists.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MASKS.RECALCULATE_MASK]: 'Recalculate mask',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.SIZE]: 'Size',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.TYPE]: 'Type',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.BOX]: 'Box',
  [I18N_KEYS.RECIPE_MAIN.NODES.BLUR.GAUSSIAN]: 'Gaussian',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXTRACT_VIDEO_FRAME.TIMECODE]: 'Timecode',
  [I18N_KEYS.RECIPE_MAIN.NODES.EXTRACT_VIDEO_FRAME.FRAME]: 'Frame',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.SELECT_AN_OPTION]: 'Select an option',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ADD_OPTIONS_VIA_PROPERTIES_PANEL]: 'No options available',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ITERATOR.PLACEHOLDER]: 'Item {{index}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ITERATOR.ADD_ITEM]: 'Add another item',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.ITERATOR.ITEMS_COUNT]: '{{count}} items',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.OPTIONS_LABEL]: 'Options',
  [I18N_KEYS.RECIPE_MAIN.NODES.LIST_NODE.OPTIONS_TOOLTIP]: 'Array of options to choose from',
  [I18N_KEYS.RECIPE_MAIN.NODES.PREVIEW_NODE.SET_AS_COVER]: 'Set as cover',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.CHANNEL]: 'Channel',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.RESET]: 'Reset',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.INPUTS]: 'Inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.HISTOGRAM]: 'Histogram',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.RED]: 'R',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.GREEN]: 'G',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.BLUE]: 'B',
  [I18N_KEYS.RECIPE_MAIN.NODES.LEVELS.NO_HISTOGRAM_DATA]: 'No data',
  [I18N_KEYS.RECIPE_MAIN.NODES.DILATION_EROSION.SIZE]: 'Size',

  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.LEARN_MORE_ABOUT_THIS_MODEL]: 'Learn more about this model',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.LLM_EDITED]: 'edited',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.OVERLAY.BATCH]: 'Batch',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ERROR_REQUIRED]: 'Missing inputs: ',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADVANCED_OPTIONS]: 'Advanced options',

  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE]:
    'Not enough credits to run the model.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_SHORT]:
    'Not enough credits.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_PART_2_FREE]:
    'Upgrade to get more credits.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_PART_2_MEMBER]:
    'Contact the workspace admin.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE
    .LOW_CREDITS_MESSAGE_PART_2_GET_MORE_CREDITS_CTA]: 'Get more credits',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.LOW_CREDITS_MESSAGE_OR]: 'or',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE
    .LOW_CREDITS_MESSAGE_PART_3_UPGRADE_CTA]: 'Upgrade.',

  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.FREE_TIER_MESSAGE]:
    '<link>Upgrade plan</link> to get more credits.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.STARTER_PRO_MESSAGE]:
    '<link>Get more credits</link>.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.TEAM_ENTERPRISE_MEMBER_MESSAGE]:
    'Please contact your workspace admin to get more.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.CREDITS_MESSAGE.TEAM_ENTERPRISE_ADMIN_MESSAGE]:
    '<link>Get more credits</link>.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.MODEL_NOT_SUPPORTED]:
    'The model type {{modelType}} is not yet supported.',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ERROR_MODEL_RUN]: 'Something went wrong. Check inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.NANO_BANANA_PRO_INTERMITTENT_ISSUES]:
    "Google's Nano Banana Pro service is experiencing intermittent issues. We recommend trying an alternative such as Seedream V5, Flux 2 Max, or GPT Image Edit 1.5",
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.TEXT_MODEL.EMPTY_STATE_PLACEHOLDER]:
    'The generated text will appear here',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_IMAGE_INPUT]: 'Add another image input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_INPUT]: 'Add another input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_VIDEO_INPUT]: 'Add another video input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_IMAGE_INPUT_DISABLED]:
    'This model supports up to {{maxInputs}} {{inputType}}',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_ELEMENT + '_one']: 'element',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_ELEMENT + '_other']: 'elements',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE + '_one']:
    'reference image',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_REFERENCE_IMAGE + '_other']:
    'reference images',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_INPUT + '_one']: 'input',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_INPUT_LIMIT_TYPE_INPUT + '_other']: 'inputs',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ANOTHER_LORA]: 'Add another LoRA',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.MODEL_NODE_FOOTER.ADD_ELEMENT]: 'Add element',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUN]: 'Run Model',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.RUNNING]: 'Running',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.CANCEL_RUN]: 'Cancel Run',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.CANCELLING]: 'Cancelling...',
  [I18N_KEYS.RECIPE_MAIN.NODES.MODEL_BASE_NODE.RUN_MODEL_BUTTON.INITIALIZING]: 'Starting',

  [I18N_KEYS.RECIPE_MAIN.NODES.SEED.RANDOM]: 'Random',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.ILLEGAL_TYPE_CONNECTION]: 'Wrong input type',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.REQUIRED_VALIDATION_ERROR]: 'Required input',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.CYCLIC_CONNECTION]: 'Circular connections are not allowed',
  [I18N_KEYS.RECIPE_MAIN.NODES.NODE_HANDLES.EMPTY_REQUIRED_VALIDATION_ERROR]: 'Required input is empty',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE + '_one']:
    '{{count}} file was not added. Only {{fileType}} are allowed in this node.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE + '_other']:
    '{{count}} files were not added. Only {{fileType}} are allowed in this node.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC + '_one']:
    '{{count}} file was not added due to an invalid file type.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.UPLOAD_ERROR_INVALID_FILE_TYPE_GENERIC + '_other']:
    '{{count}} files were not added due to invalid file types.',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_IMAGES]: 'Add more images',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_VIDEOS]: 'Add more videos',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_AUDIO]: 'Add more audio files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_3D_FILES]: 'Add more 3D files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.ADD_MORE_FILES]: 'Add more files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.IMAGES]: 'images',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.VIDEOS]: 'videos',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.AUDIO]: 'audio files',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.TEXT]: 'texts',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.THREE_D_FILES]: '3D models',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.SORT_ORDER_BY]: 'Order by',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.SORT_DATE_ADDED]: 'Date added',
  [I18N_KEYS.RECIPE_MAIN.NODES.IMPORT_NODE.SORT_NAME]: 'Name',

  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.MODE]: 'Mode',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.TOGGLE]: 'Toggle',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.SLIDER]: 'Slider',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.IMAGE]: 'Image',
  [I18N_KEYS.RECIPE_MAIN.NODES.COMPARISON.VIDEO]: 'Video',

  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.NEW_NODE]: 'New node',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.CLEAR_ALL_ASSETS]: 'Clear all',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.GROUP_ACTIONS]: 'Group',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE]: 'Label size',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE_OPTIONS.SMALL]: 'Small',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE_OPTIONS.MEDIUM]: 'Medium',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LABEL_SIZE_OPTIONS.LARGE]: 'Large',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.LOCK]: 'Lock',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.UNLOCK]: 'Unlock',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.UNGROUP]: 'Ungroup',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.DELETE]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.GROUP_CONTEXT_MENU.RESIZE_TO_FIT]: 'Resize to fit',

  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DELETE_ALL]: 'Delete',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CLEAR]: 'Clear',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CLEAR_ALL_ASSETS]: 'Clear all',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CLEAR_ALL_BUT_SELECTED]: 'Clear all but selected',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DOWNLOAD_ALL]: 'Download all',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.DUPLICATE]: 'Duplicate',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.GROUP_SELECTION]: 'Group selection',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CREATE_IMAGE_ITERATOR]: 'Create image iterator',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CREATE_VIDEO_ITERATOR]: 'Create video iterator',
  [I18N_KEYS.RECIPE_MAIN.SELECTION_CONTEXT_MENU.CREATE_TEXT_ITERATOR]: 'Create text iterator',

  [I18N_KEYS.SETTINGS.DELETE_ACCOUNT]: 'Delete Account',
  [I18N_KEYS.SETTINGS.MENU.MEMBERS]: 'Members',
  [I18N_KEYS.SETTINGS.MENU.API_KEYS]: 'Provider API Keys',
  [I18N_KEYS.SETTINGS.MENU.MODEL_MANAGEMENT]: 'Model Management',
  [I18N_KEYS.SETTINGS.MENU.PROFILE]: 'Profile',
  [I18N_KEYS.SETTINGS.MENU.SIGNOUT]: 'Sign out',
  [I18N_KEYS.SETTINGS.MENU.WORKSPACE_SETTINGS]: 'Settings',

  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TITLE]: 'Models management',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.DESCRIPTION_SHORT]:
    'Figma Weave offers both verified and unverified models to give you flexibility in your creative process.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.READ_MORE]: 'Read more',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.READ_LESS]: 'Read less',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.LABEL]: 'Auto-approve verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.DESCRIPTION]:
    "New verified models are added to your team automatically. You'll be notified by email.",
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.AUTO_APPROVE_VERIFIED.ERROR]: 'Error updating auto-approve setting',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SUBTITLE_VERIFIED]: 'Verified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TEXT_VERIFIED]:
    "Covered by Figma's terms and privacy policies. We have contractual relationships with these providers, which include requirements for how these models protect or use your data (such as prohibiting them from training on your data).",
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.SUBTITLE_UNVERIFIED]: 'Unverified models',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TEXT_UNVERIFIED]:
    'Models provided by independent third-parties, which are not controlled by Figma Weave. These models control the data you send them under their own terms, including how they protect or use your data. By approving a model you agree to the model’s own terms and policies provided in the below table.',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.HEADER_NAME]: 'Name',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.HEADER_APPROVED]: 'Approved',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.STATUS]: 'Status',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.TERMS]: 'Terms',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.HEADER_DATE_ADDED]: 'Date added',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.SEARCH_PLACEHOLDER]: 'Search models by name',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.NO_MODELS_FOUND]: 'No models found',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.TERMS]: 'Terms',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.ADDITIONAL_TERMS]: 'API terms',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.TABLE.LINKS.PRIVACY]: 'Privacy policy',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.ERROR_UPDATING_APPROVED]: 'Error updating approved list',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ALL]: 'All',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ADMIN_APPROVAL.LABEL]: 'Admin approval',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ADMIN_APPROVAL.APPROVED]: 'Approved',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.ADMIN_APPROVAL.NOT_APPROVED]: 'Blocked',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.STATUS.LABEL]: 'Verified by Figma',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.STATUS.VERIFIED]: 'Verified',
  [I18N_KEYS.SETTINGS.MODEL_MANAGEMENT.FILTERS.STATUS.NOT_VERIFIED]: 'Unverified',

  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.COPY_INVITE_LINK]: 'Copy Invite Link',
  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.DELETE]: 'Remove',
  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.RESEND_INVITE]: 'Resend Invite',
  [I18N_KEYS.SETTINGS.TEAM.ACTIONS_MENU.EDIT_LIMIT]: 'Edit Credits Limit',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.ERROR_SUBTITLE]: 'Please contact your team admin.',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.ERROR_TITLE]: 'Looks like the activation URL is not valid.',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.SUBTITLE]: 'Sign in or sign up with {{email_placeholder}} to join',
  [I18N_KEYS.SETTINGS.TEAM.ACTIVATION_PAGE.TITLE]: 'Join {{workspace_placeholder}} on Figma Weave!',
  [I18N_KEYS.SETTINGS.TEAM.CONFIRM_DELETE.CONFIRM]: 'Remove member',
  [I18N_KEYS.SETTINGS.TEAM.CONFIRM_DELETE.TITLE]: 'Remove member',
  [I18N_KEYS.SETTINGS.TEAM.EMPTY_STATE.CTA]: 'Add Your First Member',
  [I18N_KEYS.SETTINGS.TEAM.EMPTY_STATE.TITLE]: 'No one to weave with yet...',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.ENTERPRISE_SEAT_LIMIT_EXCEEDED]:
    'You have exceeded the number of seats in your plan. A Figma Weave representative will contact you in order to manage the plan according to your needs.',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS + '_one']: '1 available seat',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS + '_other']: '{{count}} available seats',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS + '_zero']: '0 available seats, but you can add more',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SEATS_ZERO_SUBTITLE]: 'New invites increase your seat count automatically',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SUCCESS_MESSAGE + '_one']: 'Member added successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SUCCESS_MESSAGE + '_other']: 'Members added successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_1 + '_one']:
    'You have exceeded the number of seats in your plan. Adding an extra member\nwill cost',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_1 + '_other']:
    'You have exceeded the number of seats in your plan. Adding {{count}} extra members\nwill cost',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_2_MONTHLY]:
    ' ${{costPerSeat}} per seat/month.\n',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_2_YEARLY]:
    ' ${{costPerSeat}} per seat/year.\n',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TEAM_SEAT_LIMIT_EXCEEDED_PART_3]:
    "You'll be charged only for the days left in this billing period, and the full amount\nwill apply on your next bill.",
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.TITLE]: 'Invite Team Members',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.SUCCESS_MESSAGE]: 'Invitation resent successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.INVITE_ERROR]: 'Error sending invite to {{emails}}',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.PARTIAL_SUCCESS + '_one']: '{{count}} invite sent successfully',
  [I18N_KEYS.SETTINGS.TEAM.INVITE_USER_MODAL.PARTIAL_SUCCESS + '_other']: '{{count}} invites sent successfully',
  [I18N_KEYS.SETTINGS.TEAM.JOIN_TEAM_SUCCESS]: "You've successfully joined the team!",
  [I18N_KEYS.SETTINGS.TEAM.REMOVE_MEMBER_DIALOG.CONTENT]:
    'Are you sure you want to remove {{email}} from this workspace?\nThey will lose access to all projects and resources in this workspace immediately.\nTheir folders and files will be transferred to you.',
  [I18N_KEYS.SETTINGS.TEAM.REMOVE_MEMBER_DIALOG.INVITED_CONTENT]:
    'Are you sure you want to cancel the invitation for {{email}}?\nThey will no longer be able to join this workspace.',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.ADD_MEMBERS_BUTTON]: 'Invite new members',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_NAME]: 'Name',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_ROLE]: 'Role',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_STATUS]: 'Status',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_CREDITS]: 'Credits',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.HEADER_USAGE]: 'Usage',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.TABLE_TITLE_SUFFIX]: 'Members',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.EDIT_LIMIT_MODAL.TITLE]: 'Edit Credits Limit',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.EDIT_LIMIT_MODAL.SUBTITLE]:
    'Set the amount of credits allocated to these members.',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.SELECTED_MEMBERS_COUNT]: '{{count}} selected',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.ALLOCATED_CREDITS]: 'Edit credits limit',
  [I18N_KEYS.SETTINGS.TEAM.TEAM_TABLE.RESET_TO_DEFAULT]: 'Reset to default credits limit',
  [I18N_KEYS.SETTINGS.TEAM.ROLES.ADMIN]: 'Admin',
  [I18N_KEYS.SETTINGS.TEAM.ROLES.MEMBER]: 'Member',
  [I18N_KEYS.SETTINGS.TEAM.UPGRADE.TEXT]:
    "Your current plan is a personal plan and doesn't support adding additional members. In order to create together, upgrade your plan.",
  [I18N_KEYS.SETTINGS.TEAM.UPGRADE.TITLE]: 'Upgrade required for team features',
  [I18N_KEYS.SETTINGS.TEAM.USER_STATUS.ACTIVE]: 'Active',
  [I18N_KEYS.SETTINGS.TEAM.USER_STATUS.INVITED]: 'Invited',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_CREDITS]: 'Credits:',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_CREDITS_CTA]: 'Get more',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_MEMBERS_CAN_SEE_CREDITS]: 'Members can see credits',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_NAME]: 'Workspace Name:',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_NAME_CHANGE]: 'Change Name',
  [I18N_KEYS.SETTINGS.TEAM.WORKSPACE_NAME_PLACEHOLDER]: 'Workspace Name',
  [I18N_KEYS.SETTINGS.TEAM.YOU]: 'You',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS.UPGRADE_CTA]: 'Get more credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS.UPGRADE_CTA_FREE_TOOLTIP]:
    'Upgrade plan to purchase additional credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PAGE_TITLE]: 'Provider API Keys',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PAGE_DESCRIPTION]:
    'To use your own accounts to run models in Weave, connect API keys from your providers.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_PROVIDER]: 'Provider',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_CREDENTIALS]: 'Credentials',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.COLUMN_STATUS]: 'Status',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.EDIT]: 'Edit',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_KEY_ARIA]: 'Delete API key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.ADD_KEY_ARIA]: 'Add API key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.ADD_TOOLTIP]: 'Add',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_TOOLTIP]: 'Delete',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.ENABLE_TOOLTIP]: 'Enable',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISABLE_TOOLTIP]: 'Disable',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.INPUT_LABEL]: 'API Key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.KEY_LABEL]: 'Enter API key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.SAVE]: 'Save',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.LOAD_FAILED]: 'Could not load API key settings. Try again later.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.OPERATION_FAILED]:
    'Something went wrong. Check your permissions and try again.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.TITLE]: 'Delete this API key?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.BODY]:
    'This will result in the provider’s models running on Weave’s native connections instead of your own.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DELETE_CONFIRM.CONFIRM]: 'Delete',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.TITLE]: 'Heads up — your provider’s terms apply',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.HEADS_UP]:
    "You're about to add your own provider API key.",
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.BODY]:
    "By clicking <bold>Continue</bold> and adding your own key, you agree that Figma's model verification and data use protections do not apply and that your agreement with the provider governs your use of their models.",
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.DISCLAIMER.CONTINUE]: 'Continue',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.API_KEY_LABEL]: 'API Key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_SERVICE_EMAIL_LABEL]: 'Service Email',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_SERVICE_EMAIL_PLACEHOLDER]:
    'service-account@project.iam.gserviceaccount.com',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PROJECT_ID_LABEL]: 'Project ID',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PROJECT_ID_PLACEHOLDER]: 'my-google-project',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PRIVATE_KEY_LABEL]: 'Private Key',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.GOOGLE_PRIVATE_KEY_PLACEHOLDER]: '-----BEGIN PRIVATE KEY-----',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.GOOGLE]: 'Google',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.API_KEYS.PROVIDERS.FAL]: 'Fal',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.TITLE]: 'Allocation',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.DEFAULT_ALLOCATION_LABEL]:
    'Default monthly credits allocation',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.UNLIMITED]: 'Unlimited',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.EDIT_DEFAULT_ALLOCATION_CTA]: 'Edit default',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.TITLE]:
    'Edit default limit',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.SUBTITLE]:
    'Set the default amount of credits allocated to new and existing users.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.CTA_CONFIRM]:
    'Apply changes',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.CTA_CANCEL]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_UNLIMITED_TITLE]:
    'No limit',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_UNLIMITED_SUBTITLE]:
    'Give users unlimited access to credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_LIMIT_TITLE]:
    'Limited credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.BUTTON_LIMIT_SUBTITLE]:
    'Give users a fixed amount of monthly credits.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_ALLOCATION.CHANGE_DEFAULT_ALLOCATION_MODAL.CREDITS_ESTIMATION_TEXT]:
    '~ {{estimatedImages}} images or {{estimatedVideos}} seconds of video',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.FORM.NAME]: 'Name',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.FORM.GENERAL]: 'General',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_TITLE]: 'Credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CURRENT_AMOUNT]: 'Current amount',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.REMAINING_MONTHLY_CREDITS_TEXT]: '{{availableMonthlyCredits}} monthly credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.EXTRA_CREDITS_TEXT]: '{{totalExtraCredits}} purchased credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.ROLLOVER_CREDITS_TEXT]: '{{totalRolloverCredits}} rollover credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDIT_THRESHOLD_ALERTS_TITLE]: 'Low credits alerts',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDIT_THRESHOLD_ALERTS_SUBTITLE]:
    'Get notified when workspace credits fall below a set threshold',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDIT_THRESHOLD_ALERTS_ERROR]: 'Failed to update low credits alerts',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.PLAN]: 'Plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.SEATS]: 'Seats',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.SEATS_SUFFIX]: 'used',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.RENEWAL_DATE]: 'Renewal date',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.EXPIRATION_DATE]: 'Expiration date',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.DOWNGRADE_TEXT]: 'Plan will change to {{plan}}',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.MONTHLY_CREDITS]: 'Monthly credits',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.MONTHLY_CREDITS_TOOLTIP_RESET]:
    'Credits are allocated monthly and reset every month.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.PLAN.MONTHLY_CREDITS_TOOLTIP_ROLLOVER]:
    'Credits are allocated monthly and roll over for up to 3 months.',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.UPGRADE]: 'Upgrade plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.MANAGE_BILLING]: 'Manage billing',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN]: 'Cancel plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.TITLE]: 'Cancel plan?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.MESSAGE + '_rollover']:
    "If you cancel, you'll lose access to your monthly and rolled-over credits when your current plan period ends on {{end_date}}.",
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.MESSAGE + '_no_rollover']:
    "If you cancel, you'll lose access to your monthly credits when your current plan period ends on {{end_date}}.",

  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.CONFIRM]: 'Cancel anyway',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CANCEL_PLAN_DIALOG.CANCEL]: 'Keep plan',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.DOWNLOAD_CREDITS_REPORT]: 'Download credits usage history',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.TITLE]: 'Download credits usage history',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.TIME_PERIOD_LABEL]: 'Select time period',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_CURRENT_CYCLE]: 'Current billing cycle',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_LAST_30_DAYS]: 'Last 30 days',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DATE_RANGE_LAST_90_DAYS]: 'Last 90 days',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.CANCEL_BUTTON]: 'Cancel',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.DOWNLOAD_BUTTON]: 'Download',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CREDITS_REPORT_MODAL.ERROR_MESSAGE]: 'Failed to download credits usage report',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CONTACT_US_PART_1]: 'Looking for an enterprise solution?',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CONTACT_US_PART_2]: 'Contact us',
  [I18N_KEYS.SETTINGS.WORKSPACE_SETTINGS.CHANGE_PLAN]: 'Change plan',

  [I18N_KEYS.SHARED_DESIGN_APP.ACTIVATION_PAGE.DEFAULT_ERROR]:
    'Invalid or expired link. Please contact the sender for a new link.',
  [I18N_KEYS.SHARED_DESIGN_APP.ACTIVATION_PAGE.TITLE]: 'Activating recipe, please wait...',
  [I18N_KEYS.SHARED_DESIGN_APP.EDIT_DESIGN_APP_BUTTON]: 'Keep Editing',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.DEFAULTS_COMMENT]: 'Set the default values for all users:',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.ADD_DESCRIPTION]: '+ Add a description',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.DESCRIPTION_PLACEHOLDER]: 'A meaningful description of this input',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.DISABLED]: 'Disabled',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.HEADER.ENABLED]: 'Enabled',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.PARAMS_DRAWER.SET_AS_INPUT]: 'Set as input',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.PROMPT.PLACEHOLDER]: 'Give a prompt example',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR]: 'This field is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_FILE]: 'File is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_LORA]: 'Please select a LoRA',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_TEXT_ITERATOR]: 'At least one option is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.REQUIRED_ERROR_MEDIA_ITERATOR]: 'At least one file is required',
  [I18N_KEYS.SHARED_DESIGN_APP.INPUTS.SET_AS_PARAMETER]: 'Set as parameter',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.BUTTON_CTA]: 'Generate one-time link',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.DEFAULT_ERROR]: 'Failed to generate share link. Please try again.',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.LINK_COPIED]: 'Link Copied!',
  [I18N_KEYS.SHARED_DESIGN_APP.MODAL.TITLE]: 'Share Design App',
  [I18N_KEYS.SHARED_DESIGN_APP.NO_INPUTS.TIP]: 'Connect the Output node to your workflow',
  [I18N_KEYS.SHARED_DESIGN_APP.NO_INPUTS.TITLE]: 'No inputs found',
  [I18N_KEYS.SHARED_DESIGN_APP.PREVIEW_DESIGN_APP_BUTTON]: 'Preview',
  [I18N_KEYS.SHARED_DESIGN_APP.PUBLISH_DESIGN_APP_BUTTON]: 'Publish',
  [I18N_KEYS.SHARED_DESIGN_APP.PUBLISH_DESIGN_APP_FAILED]: 'Design App Publish Failed!',
  [I18N_KEYS.SHARED_DESIGN_APP.PUBLISH_DESIGN_APP_SUCCESS]: 'Design App Published!',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.CURRENT_VERSION]: 'Current',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.LAST_PUBLISHED_AT]: 'Last Published At',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.LATEST_VERSION]: 'Latest Version',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.NO_VERSIONS]: 'Ready to release?',
  [I18N_KEYS.SHARED_DESIGN_APP.TOOLBAR.VIEW_VERSION]: 'View',
  [I18N_KEYS.SHARED_DESIGN_APP.NUMBER_OF_RUNS]: 'Number of Results',

  // [I18N_KEYS.SHARE_WORKFLOW_MODAL.EMAIL_LABEL]: 'Email Address',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.EMAIL_PLACEHOLDER]: 'example@email.com',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.INPUTS.PROMPT_PLACEHOLDER]: 'Describe your image',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.LINK.ANYONE]: 'Anyone with a link can view',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.LINK.RESTRICTED]: 'Only invited people can view',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.LINK.TEAM]: 'Anyone in your workspace can view',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.SHARE_BUTTON]: 'Invite',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.SHARE_BUTTON_LOADING]: 'Sending...',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.SUCCESS_MESSAGE]: 'File shared successfully',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.TITLE]: 'Invite others',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.OWNER]: 'Owner',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.ACCESS_TITLE]: 'Who has access',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.REMOVE]: 'Remove',
  [I18N_KEYS.SHARE_WORKFLOW_MODAL.FREE_PLAN_TOOLTIP]: 'Sharing is only available on paid plans',

  [I18N_KEYS.SIGN_IN_PAGE.CANT_SIGN_IN_MESSAGE]: "Can't sign in? <url>Contact us</url>",
  [I18N_KEYS.SIGN_IN_PAGE.GOOGLE_SIGN_IN_BUTTON]: 'Log in with Google',
  [I18N_KEYS.SIGN_IN_PAGE.MICROSOFT_SIGN_IN_BUTTON]: 'Log in with Microsoft',
  [I18N_KEYS.SIGN_IN_PAGE.FIGMA_SIGN_IN_BUTTON]: 'Log in with Figma',
  [I18N_KEYS.SIGN_IN_PAGE.OR]: 'or',
  [I18N_KEYS.SIGN_IN_PAGE.TITLE]: 'Welcome to Figma Weave',
  [I18N_KEYS.SIGN_IN_PAGE.SUBTITLE]: 'Start building your design machine',
  [I18N_KEYS.SIGN_IN_PAGE.TERMS_TEXT]: 'By clicking "Log in with Google, Figma, or Microsoft", you agree to',
  [I18N_KEYS.SIGN_IN_PAGE.TERMS_OF_SERVICE_LINK]: 'Figma Weave Terms of Service',
  [I18N_KEYS.SIGN_IN_PAGE.PRIVACY_POLICY_LINK]: 'Privacy Policy',
  [I18N_KEYS.SIGN_IN_PAGE.EMAIL_DOMAIN_UNAUTHORIZED]:
    'Your email domain is not authorized to sign in. For more details, please consult with your IT admin or contact support.',
  [I18N_KEYS.SIGN_IN_PAGE.EMAIL_PASSWORD_LOGIN_NOT_ALLOWED]:
    "Email/password login isn't available. Please sign in with Google or Microsoft.",
  [I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_TITLE]: 'Log in with Figma',
  [I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_BODY]: 'By clicking "Continue," you agree to the',
  [I18N_KEYS.SIGN_IN_PAGE.TOS_DIALOG_ACCEPT_BUTTON]: 'Continue',

  [I18N_KEYS.FIGMA_PROMO_WELCOME.TITLE]: 'Welcome to Figma Weave',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.BODY]:
    "You're in. Build, edit, and direct your creative workflows. Combine AI models, refine every step, and turn ideas into systems you can reuse and scale.",
  [I18N_KEYS.FIGMA_PROMO_WELCOME.CREDITS_PREFIX]: "As a Figma user, we've added ",
  [I18N_KEYS.FIGMA_PROMO_WELCOME.CREDITS_BOLD]: '1,000 credits',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.CREDITS_SUFFIX]: ' and hand-picked a few workflows for you.',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.START_FROM_SCRATCH]: 'Start from scratch',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_PREFIX]: 'Hungry for more? Watch our ',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_YOUTUBE_LINK]: 'YouTube tutorials',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_MID]: ' or join our ',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_EVENT_LINK]: 'live session',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.TUTORIAL_SUFFIX]: ' on April 16th.',
  [I18N_KEYS.FIGMA_PROMO_WELCOME.PROMO_TERMS]: 'Promo Terms',

  [I18N_KEYS.UPGRADE_MODAL.CTA]: 'Learn more...',
  [I18N_KEYS.UPGRADE_MODAL.TITLE]: 'Buy more credits for our premium models',

  [I18N_KEYS.UPLOAD_LORA_NODE.DEFAULT_WEIGHT]: 'Default Weight',
  [I18N_KEYS.UPLOAD_LORA_NODE.TRIGGER]: 'Trigger',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOADING]: 'Uploading...',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOAD_ANOTHER_BUTTON_TEXT_FILE]: 'Click to Upload another file',
  [I18N_KEYS.UPLOAD_LORA_NODE.UPLOAD_BUTTON_TEXT]: 'Click to Upload',

  [I18N_KEYS.WEAVY_MARKETING.CARDS.SOFT_LAUNCH_INVITE.SUBTITLE]:
    'Give the best creators you know access to Figma Weave.',
  [I18N_KEYS.WEAVY_MARKETING.CARDS.SOFT_LAUNCH_INVITE.TITLE]: 'Invite new Weavers',
  [I18N_KEYS.WEAVY_MARKETING.DASHBOARD_BANNER.SOFT_LAUNCH_INVITE.SUBTITLE]:
    'Bring your creative friends to Figma Weave',
  [I18N_KEYS.WEAVY_MARKETING.DASHBOARD_BANNER.SOFT_LAUNCH_INVITE.TITLE]: 'Invite new Weavers',
  [I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.TITLE]: '5,000 bonus credits with any annual plan*.',
  [I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.SUBTITLE]: 'Go too far. That is what the credits are for.',
  [I18N_KEYS.WEAVY_MARKETING.APP_BANNER.HOLIDAY_PROMO.DISCLAIMER]:
    '* Bonus credits are added on a one time basis, are not part of annual plan, and may only be added once per eligible annual plan purchase or upgrade during the campaign period. Enterprise plans are excluded from the offer. Credits have no cash value and do not apply to past purchases. Team plans receive 5,000 credits per active member added during the offer. The offer ends Nov 30 at 12:00am ET. Figma Weave may adjust or end the offer at any time.',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.CONTENT_BOTTOM]:
    'Grant access to 3 fellow designers and artists who value creativity and mastery as much as you do.',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.CONTENT_TOP]:
    "As one of our first Weavers, you're part of the community shaping the future of creative expression.",
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.ERROR_EMAIL_ALREADY_INVITED]: 'Email already invited',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.INVITE_BUTTON]: 'Invite',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.PLACEHOLDER]: 'name@example.com',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.SENT]: 'Sent',
  [I18N_KEYS.WEAVY_MARKETING.MODALS.SOFT_LAUNCH_INVITE.TITLE]: 'Invite new Weavers!',

  [I18N_KEYS.VIDEO_PREVIEW.CHANGE_TO_TIMECODE]: 'Change to timecode',
  [I18N_KEYS.VIDEO_PREVIEW.CHANGE_TO_FRAMES]: 'Change to frames',
  [I18N_KEYS.VIDEO_PREVIEW.FRAMES]: 'frames',
  [I18N_KEYS.TASK_MANAGER.TITLE]: 'Task manager',
  [I18N_KEYS.TASK_MANAGER.BATCH_NAME]: 'Batch',
  [I18N_KEYS.TASK_MANAGER.RUNNING_TEXT]: '{{count}} Running',
  [I18N_KEYS.TASK_MANAGER.CANCELLED_TEXT]: 'Cancelled',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT]: '{{failed}} runs failed - Credits refunded',
  [I18N_KEYS.TASK_MANAGER.FAILED_TEXT_NO_REFUND]: '{{failed}} runs failed',
  [I18N_KEYS.TASK_MANAGER.FAILED_STILL_RUNNING]: '{{failed}} failed, {{running}} running, {{completed}} completed',
  [I18N_KEYS.TASK_MANAGER.EMPTY_STATE]: 'No active runs',
  [I18N_KEYS.TASK_MANAGER.CLEAR_ALL]: 'Clear all',
  [I18N_KEYS.TASK_MANAGER.NO_ACTIVE_RUNS]: 'No active runs',
  [I18N_KEYS.TASK_MANAGER.TASKS]: 'Tasks',
  [I18N_KEYS.TASK_MANAGER.INITIALIZING]: 'Starting',
  [I18N_KEYS.TASK_MANAGER.BATCH_COMPLETED]: '{{completed}} / {{total}} Completed',

  [I18N_KEYS.SHORTCUTS.PANEL_TITLE]: 'Shortcuts',
  [I18N_KEYS.SHORTCUTS.ZOOM_100]: 'Zoom to 100%',
  [I18N_KEYS.SHORTCUTS.ZOOM_TO_FIT]: 'Zoom to fit',
  [I18N_KEYS.SHORTCUTS.NAVIGATION_MARK_NODES]: 'Mark section',
  [I18N_KEYS.SHORTCUTS.NAVIGATION_NAVIGATE_TO_NODES]: 'Navigate to section',
  [I18N_KEYS.SHORTCUTS.SELECT_ALL_NODES]: 'Select all nodes',
  [I18N_KEYS.SHORTCUTS.RUN_MODEL]: 'Run next model',
  [I18N_KEYS.SHORTCUTS.GROUP_SELECTION]: 'Group selection',
  [I18N_KEYS.SHORTCUTS.MOVE]: 'Move',
  [I18N_KEYS.SHORTCUTS.PAN]: 'Pan',
  [I18N_KEYS.SHORTCUTS.UNDO]: 'Undo',
  [I18N_KEYS.SHORTCUTS.REDO]: 'Redo',
  [I18N_KEYS.SHORTCUTS.CREATE_IMPORT_NODE]: 'Create import node',
  [I18N_KEYS.SHORTCUTS.CREATE_PROMPT_NODE]: 'Create prompt node',
  [I18N_KEYS.NODES.MODELS.DYNAMIC_HANDLES.IMAGE_URLS.KEY]: 'image_1',
  [I18N_KEYS.NODES.MODELS.DYNAMIC_HANDLES.IMAGE_URLS.DESCRIPTION]: 'Image to edit',

  [I18N_KEYS.CSV_COLUMN_DIALOG.TITLE]: 'Import CSV',
  [I18N_KEYS.CSV_COLUMN_DIALOG.DESCRIPTION]: 'Select columns to use as input values',
  [I18N_KEYS.CSV_COLUMN_DIALOG.COLUMN_LABEL]: 'Columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.COLUMN_PLACEHOLDER]: 'Select columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.CANCEL]: 'Cancel',
  [I18N_KEYS.CSV_COLUMN_DIALOG.CONFIRM]: 'Import',
  [I18N_KEYS.CSV_COLUMN_DIALOG.ERROR_EMPTY]: 'CSV file is empty or has no columns',
  [I18N_KEYS.CSV_COLUMN_DIALOG.ERROR_PARSE]: 'Failed to read CSV file',
  [I18N_KEYS.CSV_COLUMN_DIALOG.WARNING_TRUNCATED]: 'Values limited to {{max}} per column',
};

export default EN_TEXT;
